"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../../../../TdWebtoolkitControls/controls/List/List");
const Utilities_1 = require("../../../javascript/Utilities");
require("../../ErrorDialog/ErrorDialog.js");
const FtEditorControl_1 = require("./FtEditorControl");
exports.default = {
    impl: (ids, parentId, relId, completedHandler) => {
        require.ensure(["../../../templates/45_1.less"], function (require) {
            let markupLess = require("../../../templates/45_1.less");
            let templateMarkup = require("../../../templates/45_1.tmpl.html");
            let action = Utilities_1.synUtil.Strings.getValue("45.1");
            let windowData = Utilities_1.synUtil.popupWindow({
                title: action,
                resizable: (typeof window.synDesktopApp === "undefined"),
                actions: ["Maximize", "Close"],
                width: 800,
                height: 600,
                modal: true,
                synDesktopAware: true
            });
            let idData = {
                windowID: "popup_" + windowData.guid,
                okButtonId: "okButton_" + windowData.guid,
                ftEditorControlId: "ftEditorControl_" + windowData.guid,
                synUtil: Utilities_1.synUtil
            };
            // Create HTML from template
            let template = kendo.template(templateMarkup);
            windowData.contentDiv.html(template(idData));
            let ftEditorControl = new FtEditorControl_1.FtEditorControl($("#" + idData.ftEditorControlId), ids[0]);
            ftEditorControl.BeginAjax = () => Utilities_1.synUtil.beginAjaxProgress($("#" + idData.okButtonId));
            ftEditorControl.EndAjax = () => Utilities_1.synUtil.endAjaxProgress($("#" + idData.okButtonId));
            ftEditorControl.init();
            // OK button
            $("#" + idData.okButtonId).on("click", function () {
                if (typeof window.synDesktopApp !== "undefined")
                    window.synDesktopApp.endDialog("1");
                else {
                    ftEditorControl.unlock().then(() => {
                        $("#" + idData.windowID).data("kendoWindow").close();
                    });
                }
            });
        });
    }
};
